export const LOCAL_STORAGE_VENUE_KEY = "TICKETINGPLATFORM_VENUE";
